import type { LabeledStat } from '@/components/common/StatCardGrid';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import type { WorkSummary } from '../types/dashboard.types';

export function getWorkSummaryStatCards(
  totals: WorkSummary['totals'] | undefined,
  includesExpenses: boolean,
): LabeledStat[] {
  const dcrStats: LabeledStat[] = [
    {
      key: 'dcrCount',
      label: 'DCR Entries',
      value: totals?.dcrCount,
    },
    {
      key: 'fareAmount',
      label: 'Fare Claimed',
      value: totals?.fareAmount,
      unit: TAKA_SYMBOL,
    },
  ];
  if (!includesExpenses) return dcrStats;

  return [
    ...dcrStats,
    {
      key: 'expenseCount',
      label: 'Expenses',
      value: totals?.expenseCount,
    },
    {
      key: 'expenseAmount',
      label: 'Expense Claimed',
      value: totals?.expenseAmount,
      unit: TAKA_SYMBOL,
    },
  ];
}
